
import { Component, Prop, Vue } from 'vue-property-decorator';
import Themeable from 'vuetify/lib/mixins/themeable';

@Component({
  mixins: [
    Themeable,
  ],
})
export default class DeleteCommentDialog extends Vue {
  @Prop() private readonly data!: unknown;
  @Prop() private readonly event!: string;

  private visible: boolean = true;

  get message(): string {
    return `Are you sure you want to delete the comment?`;
  }

  private async deleteComment(): Promise<void> {
    this.$emit(this.event, this.data);
    this.destroyComponent();
  }

  private destroyComponent(): void {
    this.$emit('close');
  }
}
